import React, { useState } from "react";
import { Card, CardHeader, CardContent, Button, Typography, Grid, Box } from "@mui/material";
import { cambiarLogoEmpresa } from "../../../../store/Empresa/thunkEmpresa";
import { useDispatch } from "react-redux";
import { commonRequestData } from "../../../../api";
import Swal from "sweetalert2";
export const CambiarLogoEmpresa = ({ empresa }) => {
    const [image, setImage] = useState(null);
    const [preview, setPreview] = useState(null);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        if (file) {
            setImage(file);
            setPreview(URL.createObjectURL(file));
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const dispatch = useDispatch();
    const handleSubmit = () => {
        if (image) {
            const formData = new FormData();
            formData.append("image", image);
            formData.append("imageName", image.name);
            formData.append("imageType", image.type);

            formData.append("token_access", commonRequestData.token_access);
            formData.append("database", commonRequestData.database);
            formData.append("sqlQuery", commonRequestData.sqlQuery);
            formData.append("type", commonRequestData.type);
            formData.append("id_empresa", empresa.id_empresa);

            // Mostrar preloader
            Swal.fire({
                title: `Cambiando logo...`,
                text: "Por favor espere...",
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });

            // Llama a la acción para cambiar el estado del cliente
            dispatch(cambiarLogoEmpresa(formData));

            // Mensaje de éxito y cierre del modal
            Swal.fire({
                icon: "success",
                title: `Se ha cambiado el logo`,
                text: `Se cambio el logo de la empresa: ${empresa.nombre_empresa}`,
                confirmButtonText: "Aceptar",
                timer: 2000, // Duración de 5 segundos
                timerProgressBar: true, // Mostrar barra de progreso
            }).then(() => {
                window.location.reload(); // Recargar la página después de los 5 segundos
            });
        } else {
            alert("Se debe adjuntar o seleccionar una imagen.");
        }
    };

    return (
        <>
            <Card>
                <CardHeader title="Logo" />
                <CardContent>
                    <Typography variant="body2">Cambiar logo empresa</Typography>
                </CardContent>
            </Card>

            <Card>
                <CardHeader title="Arrastre o seleccione el logo para cambiar" />
                <CardContent>
                    <Box
                        sx={{
                            border: "2px dashed #ccc",
                            padding: 2,
                            textAlign: "center",
                            cursor: "pointer",
                        }}
                        onDrop={handleDrop}
                        onDragOver={handleDragOver}
                    >
                        <Typography variant="body2">Arrastre o seleccione una imagen</Typography>
                        <input type="file" accept="image/*" onChange={handleImageChange} style={{ display: "none" }} id="upload-logo" />
                        <label htmlFor="upload-logo" style={{ cursor: "pointer" }}>
                            <Button variant="contained" component="span">
                                Seleccionar Imagen
                            </Button>
                        </label>
                    </Box>
                    {preview && (
                        <Box mt={2}>
                            <img src={preview} alt="Logo Preview" style={{ width: "100%", maxHeight: "300px", objectFit: "contain" }} />
                        </Box>
                    )}
                    <Grid container justifyContent="flex-end" mt={2}>
                        <Button variant="contained" color="primary" onClick={handleSubmit}>
                            Cambiar Logo
                        </Button>
                    </Grid>
                </CardContent>
            </Card>
        </>
    );
};
